import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonApiService } from '../shared/services/api/common-api.service';
import { LicensureListComponent } from './licensure-list.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskDirective
  ],
  declarations: [
    LicensureListComponent
  ],
  providers: [CommonApiService, provideNgxMask()]
})
export class LicensureModule { }
